import apiClient from "./ApiInterceptor";

export const getSignature = async (user_id, amount_in_cents, currency, item_type, item_id) => {
    try {
        const params = {
            user_id: user_id,
            amount_in_cents: amount_in_cents,
            currency: currency,
            item_type: item_type,
            item_id: item_id,
        };
        const response = await apiClient.post('/wompi/signature',  params );
        return { success: true, data: response.data };
    } catch (error) {
        console.error('WompiApi - getSignature, Error generating signature:', error);
        return { success: false, error };
    }
}
